export const skipToken = Symbol('skipToken');
export type SkipToken = typeof skipToken;
